module.exports = __webpack_public_path__ + "static/media/default_yokohama_minatocdc7c30520fe11c2c2633489fe7a5dce.webp";